/**
 * Created by andrey on 22.07.2025
 */

const HeroesTab = UnitsTab.extend({
    ctor: function (codes, options) {
        this._super(codes, options);

        const contentSize = this.content.getContentSize();
        const centerPos = cc.p(contentSize.width / 2, contentSize.height / 2);

        const heroIconsLayer = new cc.Node();
        heroIconsLayer.setAnchorPoint(0.5, 0.5);
        heroIconsLayer.setPosition(centerPos);
        heroIconsLayer.setContentSize(contentSize);
        this.content.addChild(heroIconsLayer);

        const buttonsLayer = new cc.Node();
        buttonsLayer.setAnchorPoint(0.5, 0.5);
        buttonsLayer.setPosition(centerPos);
        buttonsLayer.setContentSize(contentSize);
        this.content.addChild(buttonsLayer);

        this.families.forEach((family) => {
            if (family.heroIcon) {
                family.heroIcon.replaceParentSamePlace(heroIconsLayer);
            }
            if (family.helpButton) {
                family.helpButton.replaceParentSamePlace(buttonsLayer);
            }
        });
    },

    createFamilies: function (codes, options) {
        const heroes = HeroesTab.listHeroes();
        const styles = cleverapps.styles.HeroesTab;

        return heroes.map((hero) => {
            const units = hero.code ? cleverapps.unitsLibrary.listOpenedPlusOneWithUnknown(hero.code) : [];

            if (units.length > 0) {
                units[units.length - 1].selected = true;
            }

            return new HeroDetailsLayout(hero, units, {
                width: styles.size[cleverapps.resolution.mode].width,
                resolutionMode: options.resolutionMode
            });
        });
    }
});

HeroesTab.listHeroes = function () {
    const nextHero = cleverapps.unitsLibrary.getCurrentHero();

    const heroes = cleverapps.unitsLibrary.listCodesByType("hero").map((code) => {
        if (cleverapps.unitsLibrary.isHeroAvailable(code) || nextHero === code) {
            return {
                code,
                stage: Families[code].units.length - 1,
                type: "hero"
            };
        }
        return {
            type: "hero",
            unknownHero: true
        };
    });

    for (let i = 0; i < HeroesTab.UNKNOWN_HEROES; ++i) {
        heroes.push({
            type: "hero",
            unknownHero: true
        });
    }

    return heroes;
};

HeroesTab.UNKNOWN_HEROES = cleverapps.config.name === "mergecraft" ? 1 : 3;

cleverapps.styles.HeroesTab = {
    size: [{ width: 894 }, { width: 1334 }, { width: 1334 }]
};
